<!--TelaDeInscricao.svelte-->
<script>
  import {
    ItemInserir,
    Tipo,
    generateCreateTableSQL,
  } from "../../Classes/ItemInserir";
  import InserirDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
  import AccordionItem from "../../componentes_basicos/AccordionItem.svelte"; // Import the new AccordionItem component
  import Motivacional from "../../componentes_basicos/Motivacional.svelte";
  import BotaoLixeira from "../../componentes_basicos/BotaoLixeira.svelte";
  import CompiladorDeInserirDados from "../../Componentes/InsercaoDados/CompiladorDeInserirDados.svelte";
  import ArmazenaVariaveisLogin from "../../Classes/ArmazenaVariaveisLogin";
  import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
  import Constantes from "../../Classes/Constantes";
  import InserirDadosAcordion from "../../Componentes/InsercaoDados/InserirDadosAcordion.svelte";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import InputValidacao from "../../componentes_basicos/InputValidacao.svelte";
  import { DadosPaginaAnterior } from "../../Classes/Stores";
  import Conexoes from "../../Classes/Conexoes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import Loading from "../../componentes_basicos/Loading.svelte";

  const api_inscricao_campeonato = Constantes.api_inscricao_campeonato;
  const apiEdicaoCadastro = Constantes.api_editar_padrao;
  const apiConsultaCadastro = Constantes.api_consultar_padrao;
  const query_code_inserir_cadastro_nao_logado = "inserir_usuario_nao_logado";
  const query_code_carrega_dados_usuario_cadastrado =
    "carrega_dados_usuario_cadastrado_inscricoes";
  const tabela_cadastro = Constantes.nome_tabela_cadastrar_usuarios_incricao;
  const tabela = "";

  let aguardarCarregamentoInicial = false;
  let conexao = new Conexoes();
  export let params; //vem por roteamento
  let id_campeonato = params;
  let carregando = false;
  let tituloAcordion = 'Inscrição';
  let rotuloAcordion = "Atleta ";
  let parametrosInputValidacao = {
    query_code: "consulta_cupom",
    id_campeonato: id_campeonato,
  };
  // let apiInputValidacao = Constantes.api_consultar_padrao;
  let apiInputValidacao = "consultas.php";
  //console.log("id_campeonato", id_campeonato);
  //console.log("ID USUARIO", ArmazenaVariaveisLogin.dados.id_usuario);
  let voltarPagina = Constantes.tela_pre_inscricao + "?id=" + id_campeonato;
  let precoCategoria = "";
  let numeroAteltas = 0;

  let totalItens = {};
  let rotuloCategoria = "Categoria";
  let AberturaAccordion = [rotuloCategoria];
  let ArmazenaInscricaoItens = [];
  let ArmazenaNomeTime = [];
  let categoria = [];

  let nomeTime = [
    new ItemInserir({
      rotulo: "Nome da equipe (opcional)",
      nomeColuna: "nome_time",
      tamanho: 70,
      tipo: Tipo.TEXTO,
    }),
  ];
  let cupom = [
    new ItemInserir({
      rotulo: "Cupom promocional",
      nomeColuna: "codigo_cupom",
      obrigatorio: false,
      tamanho: 100,
      tipo: Tipo.TEXTO_VALIDADO,
    }),
  ];

  let inscricaoItens = [
    new ItemInserir({
      rotulo: "Nome",
      nomeColuna: "nome_usuario",
      tamanho: 100,
      tipo: Tipo.NOME_SOBRENOME,
      obrigatorio: true,
    }),
    new ItemInserir({
      rotulo: "Nome do BOX (opcional)",
      nomeColuna: "box",
      tamanho: 70,
      tipo: Tipo.TEXTO,
      obrigatorio: false,
    }),
    new ItemInserir({
      rotulo: "CPF",
      nomeColuna: "cpf",
      tamanho: 20,
      tipo: Tipo.CPF,
      obrigatorio: true,
    }),
    new ItemInserir({
      rotulo: "Data de nascimento",
      nomeColuna: "data_nascimento",
      tamanho: 10,
      tipo: Tipo.DATA,
      obrigatorio: true,
    }),
    new ItemInserir({
      rotulo: "Gênero",
      nomeColuna: "genero",
      tamanho: 30,
      tipo: Tipo.SELECAO,
      obrigatorio: true,
      config_drop_down: {
        api: Constantes.api_consultar_padrao,
        nome_coluna_saida: "genero",
        filtravel: false,
        itens: ["Masculino", "Feminino", "Outro"],
      },
    }),

    new ItemInserir({
      rotulo: "Tamanho de Camisa",
      nomeColuna: "tamanho_camisa",
      tamanho: 30,
      tipo: Tipo.SELECAO,
      obrigatorio: true,
      config_drop_down: {
        api: Constantes.api_consultar_padrao,

        parametros: {
          query_code: "consulta_generica_campeonato",
          tabela: "tamanhos_camisa",
          id_campeonato: id_campeonato,
        },
        nome_coluna_opcoes: "tamanho_roupa",
        nome_coluna_saida: "id",
        filtravel: true,
        itens: "",
      },
    }),

    new ItemInserir({
      rotulo: "Benchmarks do atleta",
      nomeColuna: "divisor_benchmark",
      strong: true,

      tipo: Tipo.DIVISOR,
    }),
    new ItemInserir({
      rotulo: "PR Backsquat (KG)",
      nomeColuna: "pr_backsquat",
      tamanho: 5,
      tipo: Tipo.DECIMAL,
      casas_decimais: 1,
    }),
    new ItemInserir({
      rotulo: "PR Clean and Jerk (KG)",
      nomeColuna: "pr_clean_and_jerk",
      tamanho: 5,
      tipo: Tipo.DECIMAL,
      casas_decimai: 1,
    }),
    new ItemInserir({
      rotulo: "PR Clean (KG)",
      nomeColuna: "pr_clean",
      tamanho: 5,
      tipo: Tipo.DECIMAL,
      casas_decimai: 1,
    }),
    new ItemInserir({
      rotulo: "PR Snatch (KG)",
      nomeColuna: "pr_snatch",
      tamanho: 5,
      tipo: Tipo.DECIMAL,
      casas_decimai: 1,
    }),
    new ItemInserir({
      rotulo: "PR Deadlift (KG)",
      nomeColuna: "pr_deadlift",
      tamanho: 5,
      tipo: Tipo.DECIMAL,
      casas_decimai: 1,
    }),
    new ItemInserir({
      rotulo: "Max Pullup",
      nomeColuna: "max_pullup",
      tamanho: 3,
      tipo: Tipo.NUMERO,
    }),
    new ItemInserir({
      rotulo: "Benchmark Grace (min:sec)",
      nomeColuna: "benchmark_grace",
      tamanho: 5,
      tipo: Tipo.HORA,
    }),
    new ItemInserir({
      rotulo: "Benchmark Fran (min:sec)",
      nomeColuna: "benchmark_fran",
      tamanho: 5,
      tipo: Tipo.HORA,
    }),
    new ItemInserir({
      rotulo: "Benchmark Ellen (min:sec)",
      nomeColuna: "benchmark_ellen",
      tamanho: 5,
      tipo: Tipo.HORA,
    }),
    new ItemInserir({
      rotulo: "Benchmark Karen (min:sec)",
      nomeColuna: "benchmark_karen",
      tamanho: 5,
      tipo: Tipo.HORA,
    }),
    new ItemInserir({
      rotulo: "Time Run 5 KM (min:sec)",
      nomeColuna: "time_run_5km",
      tamanho: 5,
      tipo: Tipo.HORA,
    }),
  ];

  ////console.log(generateCreateTableSQL("benchmarks",inscricaoItens));

  async function PegaDrops(e) {
   
    if (e.detail.nomeDrop && e.detail.nomeDrop.toLowerCase() == rotuloCategoria.toLowerCase()) {
      console.log(e.detail);
      rotuloAcordion = e.detail.objeto.rotulo_acordion;
      numeroAteltas = e.detail.objeto.numero_atleta_equipe;
      let cat= e.detail.objeto.id;
      //vamos agora habilitar ou desabilitar itens da lista conforme o bd

      await VerificaHabilitados(cat);

      await AjustaLista();
    }

    //console.log(e.detail.objeto);
  }

  function ArmazenamentoInicial() {
    //faz uma copia incial das listas;
 AberturaAccordion = [rotuloCategoria];

categoria = [
    new ItemInserir({
      nomeColuna: "id_campeonato",
      valor: id_campeonato,
      tipo: Tipo.HIDDEN,
    }),
    new ItemInserir({
      nomeColuna: "id_usuario",
      valor: ArmazenaVariaveisLogin.dados.id_usuario,
      tipo: Tipo.HIDDEN,
    }),
    new ItemInserir({
      rotulo: rotuloCategoria,
      nomeColuna: "categoria",
      tamanho: 30,
      tipo: Tipo.SELECAO,
      obrigatorio: true,
      config_drop_down: {
        api: Constantes.api_consultar_padrao,

        parametros: {
          query_code: "consulta_generica_campeonato",
          tabela: "categorias_campeonatos_view",
          id_campeonato: id_campeonato,
        },
        nome_coluna_opcoes: "nome_categoria_completo",
        nome_coluna_saida: "id",
        filtravel: false,
        itens: "",
        nome_drop: rotuloCategoria,
      },
    }),
  ];

    ArmazenaInscricaoItens = [...inscricaoItens];

    ArmazenaNomeTime = [...nomeTime];
  }
  async function VerificaHabilitados(cat) {
    carregando = true;

    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "config_inscricao",
      id: cat,
    });

    inscricaoItens = [...ArmazenaInscricaoItens];

    nomeTime = [...ArmazenaNomeTime];

    if (result && result.length > 0) {
      // Filtra os itens desabilitados

      const colunasDesabilitadas = result.map((item) => item.nome_coluna);

      // Filtra os itens de cadastroItens que não estão desabilitados
      inscricaoItens = inscricaoItens.filter(
        (item) => !colunasDesabilitadas.includes(item.nomeColuna),
      );

      console.log(inscricaoItens);
      console.log("colunas desabilitadas", colunasDesabilitadas);
      nomeTime = nomeTime.filter(
        (item) => !colunasDesabilitadas.includes(item.nomeColuna),
      );
    }
    carregando = false;
  }

  async function VerificaRotulo() {
    carregando = true;

    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "consultar_campeonato",
      id_campeonato: id_campeonato,
    });

    if (result && result.length > 0) {
      // Filtra os itens desabilitados

      rotuloCategoria = result[0].rotulo_categoria;
       tituloAcordion = result[0].titulo_acordion;
       console.log("titulo",tituloAcordion);
    }
   
    carregando = false;
    aguardarCarregamentoInicial = true;
  }
  async function VerificaCupomObrigatorio() {
    carregando = true;
    let conexao = new Conexoes();
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "cupom_obrigatorio",
      id_campeonato: id_campeonato,
    });

    if (result && result.length > 0) {
      cupom[0].obrigatorio = true;
    }
    carregando = false;
  }
  function AjustaLista(apaga=true) {
    // Resetar totalItens antes de ajustar a lista
    if(apaga){
      totalItens = {};
    }
   
    totalItens[rotuloCategoria] = categoria;
    for (let index = 1; index <= numeroAteltas; index++) {
      let i = index;
      if (numeroAteltas == 1) {
        i = "";
      }
      totalItens[rotuloAcordion + i] = inscricaoItens.map((item) => {
        // Criar uma nova instância de ItemInserir para cada item
        return new ItemInserir({
          ...item,
          valor: "", // Resetar o valor para garantir que cada atleta tenha seus próprios valores
        });
      });
    }
    if (numeroAteltas > 0) {
      totalItens["Cupom"] = cupom;
    }
    if (numeroAteltas > 1) {
      let t = [...categoria, ...nomeTime];
      totalItens[rotuloCategoria] = t;
    }
  }


  onMount(async () => {
    await params;
    await id_campeonato;
    id_campeonato = params;
    await  VerificaRotulo();
    await VerificaCupomObrigatorio();
   await  ArmazenamentoInicial();
    //console.log("id campeonato ", params);
  await  AjustaLista();
    
  });
  function Resultado(e) {
    let id_inscricao = e.detail.id_cod_inscricao;
    DadosPaginaAnterior.set({ id_campeonato: id_campeonato });
    navigate(Constantes.tela_pre_pagamento + "?id=" + id_inscricao);
  }
  export let valor = 1; // Valor inicial
  export let minimo = 1; // Valor mínimo permitido
  export let maximo = 10; // Valor máximo permitido
   function incrementar() {
    if (valor < maximo) {
      valor++;
    }
    numeroAteltas=valor;
    AjustaLista(false);
  }

  // Função para decrementar o valor
   function decrementar() {
    if (valor > minimo) {
      valor--;
    }
    numeroAteltas=valor;
     AjustaLista(false);
  }
  function AjustaListaSemApagar() {
  // Faz uma cópia do estado atual de totalItens
  
  let novoTotalItens = { ...totalItens };

  // Atualiza o valor da chave correspondente à categoria atual
  novoTotalItens[rotuloCategoria] = categoria;
  
  // Adiciona ou atualiza os itens do atleta conforme a seleção
  for (let index = 0; index < numeroAteltas; index++) {
    const rotuloAtleta = `${rotuloAcordion}${index + 1}`;
    
    // Se o item já existe em totalItens, preserva-o. Caso contrário, insere os novos itens.
    novoTotalItens[rotuloAtleta] = novoTotalItens[rotuloAtleta] || [...ArmazenaInscricaoItens];
  }

  // Atualiza totalItens com o novo valor
  totalItens = { ...novoTotalItens };
}
</script>

<LoadingTela isLoading={carregando} />
{#if aguardarCarregamentoInicial}
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <InserirDadosAcordion
          possuiLoading={true}
          centralizado={true}
          on:retorna_drops={PegaDrops}
          titulo={tituloAcordion}
          api={api_inscricao_campeonato}
          strong={true}
          itens={totalItens}
          botaoProsseguir={numeroAteltas < 1 ? false : true}
          query_code_carregar_edicao={query_code_carrega_dados_usuario_cadastrado}
          {AberturaAccordion}
          {parametrosInputValidacao}
          {apiInputValidacao}
          {voltarPagina}
          parametro_adicional={id_campeonato}
          parametro_adicional2={rotuloAcordion}
          mensagemDuplicado={Constantes.msg_inscricao_duplicada}
          on:sucesso={(e) => Resultado(e)}
        >
        {#if numeroAteltas>0}
        <!--
        <br>
        <p>Deseja inscrever amigos ? Adicione a quantidade de inscrições desejadas</p>
        <button class="btn-decremento" on:click={decrementar} disabled={valor <= minimo}>
          -
        </button>
        <span class="valor">{valor}</span>
        <button class="btn-incremento" on:click={incrementar} disabled={valor >= maximo}>
          +
        </button>
        -->
        <div class="mb-3 mt-2 padraoAviso">
          <i
            >Ao clicar no botão abaixo significa que você concorda com o <b
              >Regulamento da Competição</b
            >
            além dos
            <b
              >Termos de uso, política de privacidade e cookies da Plataforma
              Wodoxi.</b
            > 
          </i>
        </div>
        {/if}
        </InserirDadosAcordion>
       
        
      </div>

      <div class="col-md-6 d-none d-md-block">
        <div class="card-container">
          <Motivacional />
        </div>
      </div>
    </div>
  </div>
{/if}

<style> 

.btn-decremento, .btn-incremento {
  background-color: #007bff;
  color: white;
  font-size: 20px;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 5px;
  transition: background-color 0.3s;
}

.btn-decremento:disabled, .btn-incremento:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.btn-decremento:hover:not(:disabled), .btn-incremento:hover:not(:disabled) {
  background-color: #0056b3;
}

.valor {
  font-size: 18px;
  font-weight: bold;
  width: 50px;
  text-align: center;
}  .padraoAviso {
    background-color: #d6eaf8;
    text-align: center;
  }
  .container {
    max-width: 1280px;
    margin: 50px auto;
    padding: 1rem;
  }

  .card-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh; /* Ocupa toda a altura da tela */
  }

  .card {
    width: 300px;
    text-align: center;
  }
  .imagem {
    max-width: 100%;
  }
  textarea#regulamento {
    height: 150px;
    overflow-y: auto;
  }
  .add-remove-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .rounded-circle {
    width: 40px;
    height: 40px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    border: 1px solid #dee2e6; /* Contorno sombreado leve */
    margin: 10px;
  }

  .rounded-circle:hover {
    background-color: #f8f9fa; /* Altera a cor de fundo ao passar o mouse */
  }
</style>
